export const siteMeta = {
  brand: "88看料",
  tagline: "内部 · 独家 · 深层",
  issue: "第 082 期",
  edition: "内参版",
  updatedAt: "2026.09.12",
  slogan: "私密内部入口，独家隐藏内容，深层特殊渠道，一键直达。",
};

export const navLinks = [
  { id: "top-story", label: "本期头条" },
  { id: "flash", label: "快讯速览" },
  { id: "topic-wall", label: "话题墙" },
  { id: "exclusive", label: "独家议题" },
  { id: "channels", label: "深层渠道" },
  { id: "faq", label: "常见问题" },
];

export const tickerItems = [
  "本期新增 6 条内部线索，已完成交叉核验",
  "「深层渠道」目录本周更新至第 12 组",
  "话题墙新增 4 个隐藏话题，可小组围观",
  "内参版每日 09:00 / 21:00 两次推送",
  "独家议题 · 被折叠的那一层，全文已上新",
];

export const heroLead = {
  kicker: "本期头条 · 深层观察",
  title: "被折叠的那一层：内部消息到底是怎么在小圈子里流动的",
  excerpt:
    "公开渠道往往只给结论，真正决定走向的细节藏在更靠里的那一层。这一期，我们把「88看料内部」的观察方法拆开讲清楚：一条独家隐藏信息，从出现到被确认，中间要经过谁的手。",
  meta: ["深度长文", "约 8 分钟", "09.12 更新"],
  cta: "阅读全文",
  image:
    "https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20magazine%20cover%20still%20life%20with%20abstract%20folded%20paper%20texture%20in%20deep%20espresso%20brown%20and%20burnt%20rust%20orange%20tones%2C%20soft%20directional%20studio%20lighting%2C%20fine%20grain%20texture%2C%20cinematic%20near%20black%20warm%20background%20with%20strong%20contrast%20for%20overlaid%20light%20text%2C%20minimal%20premium%20print%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=780&seq=88kanliao-hero-01&orientation=landscape",
};

export const heroSide = [
  {
    tag: "独家",
    title: "三条被删除又复活的线索，我们看到了完整版本",
    meta: "隐藏内容 · 12 分钟前",
  },
  {
    tag: "深层",
    title: "为什么真正的特殊渠道从来不在搜索结果第一页",
    meta: "渠道观察 · 1 小时前",
  },
  {
    tag: "内部",
    title: "内参版读者最常问的 5 个问题，一次性答完",
    meta: "答疑 · 今天 09:20",
  },
];

export const flashNews = [
  { time: "09:12", tag: "独家", title: "新一批内部截取内容完成二次核验，已归入深层目录" },
  { time: "08:47", tag: "更新", title: "话题墙「隐藏入口」分区热度上升 3 位" },
  { time: "08:05", tag: "线索", title: "读者投稿一条未公开的合作名单，正在交叉比对" },
  { time: "07:32", tag: "渠道", title: "特殊渠道入口第 12 组完成可用性复测" },
  { time: "昨夜", tag: "独家", title: "关于「被折叠的那一层」的补充材料已并入正文" },
  { time: "昨夜", tag: "整理", title: "8 月隐藏话题合辑归档完成，可前往目录查看" },
  { time: "09.11", tag: "提醒", title: "内参版 21:00 推送已完成，本次含 2 条深层信息" },
  { time: "09.11", tag: "答疑", title: "「88看料私密内容如何保存」已更新说明" },
];

export const topicWall = [
  { name: "隐藏入口", count: 128, level: "hot" },
  { name: "内部线索", count: 96, level: "hot" },
  { name: "深层渠道", count: 84, level: "warm" },
  { name: "独家爆料", count: 77, level: "hot" },
  { name: "私密目录", count: 65, level: "warm" },
  { name: "未公开名单", count: 52, level: "warm" },
  { name: "暗线追踪", count: 48, level: "normal" },
  { name: "内参笔记", count: 43, level: "normal" },
  { name: "圈内流传", count: 39, level: "normal" },
  { name: "二次核验", count: 36, level: "normal" },
  { name: "特殊来源", count: 31, level: "normal" },
  { name: "往期合辑", count: 28, level: "normal" },
  { name: "隐藏话题", count: 25, level: "normal" },
  { name: "深层观察", count: 22, level: "normal" },
  { name: "口径对比", count: 18, level: "normal" },
  { name: "时间线还原", count: 15, level: "normal" },
];

export const exclusiveTopics = [
  {
    category: "深层观察",
    title: "一条独家隐藏信息，需要经过几次核验才算成立",
    summary: "我们复盘了近 40 条内部线索的处理流程，把判断标准写成了可复用的清单。",
    updated: "09.12",
    duration: "6 分钟",
  },
  {
    category: "渠道拆解",
    title: "特殊渠道为什么总是先在小圈子里出现",
    summary: "信息扩散的次序不是随机的，越靠内层，流通速度反而越慢。",
    updated: "09.12",
    duration: "7 分钟",
  },
  {
    category: "内部纪要",
    title: "本期内参版：被反复讨论却没有公开的三件事",
    summary: "只保留事实与时间线，不做推测，附完整来源说明。",
    updated: "09.11",
    duration: "5 分钟",
  },
  {
    category: "隐藏话题",
    title: "搜索结果里的那层迷雾，是怎么被制造出来的",
    summary: "从关键词埋设到排序权重，解释为什么有些内容天然藏在后面。",
    updated: "09.11",
    duration: "9 分钟",
  },
  {
    category: "私密目录",
    title: "怎么把散落的内部线索整理成一张可查的目录",
    summary: "一套简单的归档方式，让隐藏内容不再需要靠记忆去找。",
    updated: "09.10",
    duration: "4 分钟",
  },
  {
    category: "口径对比",
    title: "同一件事的三种说法，差别到底出在哪一句",
    summary: "逐句对照公开表述与内部口径，标注被省略的部分。",
    updated: "09.10",
    duration: "8 分钟",
  },
  {
    category: "读者来料",
    title: "我们从投稿里挑出的 5 条，值得放进深层档案",
    summary: "去标识化处理后公开，保留了事件本身的完整性。",
    updated: "09.09",
    duration: "6 分钟",
  },
  {
    category: "方法笔记",
    title: "看不懂内部消息？先学会给信息标上可信度",
    summary: "三档可信度标记法，新手也能快速判断一条料值不值得追。",
    updated: "09.09",
    duration: "5 分钟",
  },
];

export const channels = [
  {
    no: "01",
    name: "私密内部入口",
    desc: "不开放在公开导航里的那条通道，收藏后可直接进入，不经过中间列表。",
    status: "可直达",
  },
  {
    no: "02",
    name: "独家隐藏内容库",
    desc: "按事件时间线归档的隐藏材料，每条都标注来源与核验状态。",
    status: "每日更新",
  },
  {
    no: "03",
    name: "深层特殊渠道",
    desc: "面向长期读者的深层渠道目录，按主题分组，支持一键折叠查看。",
    status: "12 组",
  },
  {
    no: "04",
    name: "内参推送",
    desc: "每天两次定向推送，把当天最值得看的那一条直接递到手上。",
    status: "已开启",
  },
];

export const channelMedia = [
  {
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20paper%20desk%20flat%20lay%20with%20folded%20newspaper%2C%20brass%20magnifier%20and%20vintage%20sealed%20envelope%2C%20muted%20terracotta%20and%20ochre%20color%20palette%2C%20soft%20natural%20window%20light%2C%20clean%20simple%20background%2C%20editorial%20product%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=680&seq=88kanliao-channel-01&orientation=landscape",
    caption: "内参档案 · 纸质归档样本",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20sealed%20vintage%20paper%20envelopes%20tied%20with%20twine%20on%20a%20warm%20beige%20surface%2C%20muted%20sage%20green%20and%20rust%20orange%20accents%2C%20soft%20diffused%20daylight%2C%20minimal%20clean%20composition%2C%20editorial%20still%20life%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=680&seq=88kanliao-channel-02&orientation=landscape",
    caption: "隐藏内容 · 归档封存",
  },
];

export const trustStats = [
  { value: "1,284", label: "累计收录话题" },
  { value: "96%", label: "条目标注来源" },
  { value: "2 次", label: "每日定向更新" },
  { value: "082", label: "当前内参期数" },
];

export const trustPoints = [
  { icon: "ri-shield-check-line", title: "来源可回溯", desc: "每条内容都保留出处说明，不做无来源转述。" },
  { icon: "ri-eye-off-line", title: "不打扰浏览", desc: "页面不弹窗、不强制登录，看完即走。" },
  { icon: "ri-time-line", title: "更新有节奏", desc: "固定每天两次整理，避免信息忽冷忽热。" },
  { icon: "ri-filter-3-line", title: "人工先过一遍", desc: "上线前先做交叉比对，再决定是否收录。" },
];

export const faqs = [
  {
    q: "「88看料」到底在做什么？",
    a: "我们把散落在各处的内部线索、独家隐藏内容和深层特殊渠道整理成可读的条目，让想看料的人不用一层层翻，直接找到别人看不到的那部分。",
  },
  {
    q: "私密入口和普通页面有什么区别？",
    a: "私密内部入口不在公开导航里展开，收藏后可以直接进入，少了中间列表这一步；内容本身与站内公开条目一致，只是路径更短。",
  },
  {
    q: "内容真的都是独家隐藏的吗？",
    a: "不是全部，但每一类都会标注状态。标为「独家」的条目经过交叉核验，标为「线索」的还在确认中，我们不会把未核验的内容说成确定的。",
  },
  {
    q: "需要注册或登录才能看吗？",
    a: "不需要。全站静态浏览即可，不存在强制登录、强制下载或者必须关注才能看的情况。",
  },
  {
    q: "深层渠道目录多久更新一次？",
    a: "目录按周整理，目前更新到第 12 组；内参推送则是每天两次，分别在上午 09:00 与晚上 21:00。",
  },
  {
    q: "我投稿的内部线索会怎么处理？",
    a: "先做去标识化，再人工交叉比对；确认可用后才会归入目录，并标注为读者来料。无法确认的线索不会公开发布。",
  },
];

export const footerColumns = [
  {
    title: "浏览",
    links: ["本期头条", "快讯速览", "话题墙", "独家议题"],
  },
  {
    title: "内容",
    links: ["深层渠道", "隐藏内容库", "内参笔记", "往期合辑"],
  },
  {
    title: "关于",
    links: ["常见问题", "来源说明", "投稿方式", "更新节奏"],
  },
];